/* Shared collection/search pagination. Keep each batch tied to its current grid. */
(function () {
  'use strict';
  var active = null, scheduled = false;
  function current(s) { return active === s && s.grid.isConnected && !s.container.querySelector('.collection.loading'); }
  function field(root, name) { return root.querySelector('[data-' + name + ']'); }
  function read(root, name) { var node = field(root, name); return node ? node.value : ''; }
  function write(root, name, value) { var node = field(root, name); if (node) node.value = value; }
  function dispose() {
    if (!active) return;
    if (active.observer) active.observer.disconnect();
    if (active.controller) active.controller.abort();
    if (active.infinite) document.documentElement.style.overflowAnchor = active.anchorStyle;
    active = null;
  }
  function showing() {
    var grid = document.querySelector('.load-more-grid');
    if (!grid) return;
    var total = Number(read(document, 'total-products'));
    if (!Number.isFinite(total) || !field(document, 'total-products')) return;
    var count = Math.min(grid.children.length, total);
    document.querySelectorAll('.showing-text').forEach(function (node) {
      node.textContent = /^fr\b/i.test(document.documentElement.lang)
        ? count + (total === 1 ? ' produit affiché sur ' : ' produits affichés sur ') + total
        : 'Showing ' + count + ' of ' + total + (total === 1 ? ' product' : ' products');
    });
  }
  function busy(s, value) {
    s.control.classList.toggle('loading', value);
    s.control.setAttribute('aria-busy', String(value));
    if (s.control.tagName === 'BUTTON') s.control.disabled = value;
    var message = s.control.querySelector('[data-scroll-status]');
    if (message) message.textContent = value ? (/^fr\b/i.test(document.documentElement.lang) ? 'Chargement des produits' : 'Loading more products') : '';
  }
  function error(s) {
    s.failed = true;
    var retry = s.control.querySelector('[data-infinite-retry]');
    if (retry) { retry.hidden = false; retry.style.display = ''; }
    var message = s.control.querySelector('[data-scroll-status]');
    if (message) message.textContent = /^fr\b/i.test(document.documentElement.lang) ? 'Impossible de charger les produits. Veuillez réessayer.' : 'Products could not be loaded. Please try again.';
  }
  function fetchBatch(s) {
    if (s.pending) return s.pending;
    if (!s.next) return Promise.reject(new Error('No next page'));
    var url = new URL(s.next, location.origin);
    if (url.origin !== location.origin) return Promise.reject(new Error('Invalid page URL'));
    // Preserve Shopify's cursor, filters and sorting, while omitting the full page layout.
    if (s.grid.dataset.id) url.searchParams.set('section_id', s.grid.dataset.id);
    s.controller = new AbortController();
    var timeout = setTimeout(function () { s.controller.abort(); }, 20000);
    s.pending = fetch(url.href, {signal: s.controller.signal}).then(function (response) {
      if (!response.ok) throw new Error('Page request failed');
      return response.text();
    }).then(function (html) {
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var grid = parsed.querySelector('.load-more-grid');
      if (!grid || grid.dataset.id !== s.grid.dataset.id || !grid.children.length) throw new Error('Invalid product batch');
      var root = grid.closest('#ProductGridContainer') || parsed;
      var page = Number(read(root, 'current-page')) || s.page + 1;
      var next = read(root, 'next-url');
      if (page <= s.page || (next && next === s.next)) throw new Error('Repeated product batch');
      return {grid: grid, page: page, next: next};
    }).finally(function () { clearTimeout(timeout); });
    // A prefetch failure must remain retryable rather than become an unhandled rejection.
    s.pending.catch(function () {});
    return s.pending;
  }
  async function append(s, retrying) {
    if (!current(s) || s.loading || !s.next || (s.failed && !retrying)) return;
    s.loading = true; s.failed = false;
    var retry = s.control.querySelector('[data-infinite-retry]');
    if (retry) { retry.hidden = true; retry.style.display = 'none'; }
    busy(s, true);
    try {
      var batch = await fetchBatch(s);
      if (!current(s)) return;
      var assets = new Set(Array.from(document.querySelectorAll('script[src],link[href]')).map(function (node) { return node.src || node.href; }));
      batch.grid.querySelectorAll('script[src],link[href]').forEach(function (node) {
        if (assets.has(node.src || node.href)) node.remove();
      });
      var fragment = document.createDocumentFragment();
      while (batch.grid.firstChild) fragment.appendChild(batch.grid.firstChild);
      s.grid.appendChild(fragment);
      s.page = batch.page; s.next = batch.next; s.pending = null;
      write(s.container, 'current-page', s.page);
      write(s.container, 'next-url', s.next);
      showing();
      if (typeof window.colorSwatches === 'function') window.colorSwatches(s.grid);
      if (!s.next) { s.control.remove(); if (s.observer) s.observer.disconnect(); }
    } catch (e) {
      if (current(s)) { s.pending = null; error(s); }
    } finally {
      s.loading = false;
      if (current(s)) { busy(s, false); if (s.failed) error(s); else schedule(); }
    }
  }
  function check() {
    var s = active;
    if (!s || !s.infinite || !current(s) || !s.next || s.failed) return;
    var rect = s.control.getBoundingClientRect();
    if (rect.top <= window.innerHeight + 1400) fetchBatch(s).catch(function () {});
    if (rect.top <= window.innerHeight + 650) append(s, false);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; check(); });
  }
  function init() {
    var grid = document.querySelector('.load-more-grid');
    if (active && active.grid === grid) { showing(); schedule(); return; }
    dispose();
    if (!grid) return;
    var container = grid.closest('#ProductGridContainer') || grid.parentElement;
    var control = container.querySelector('.js-infinite-scroll, .js-load-more');
    showing();
    if (!control || !read(container, 'next-url')) return;
    var s = active = {grid: grid, container: container, control: control, infinite: control.classList.contains('js-infinite-scroll'), next: read(container, 'next-url'), page: Number(read(container, 'current-page')) || 1, pending: null, controller: null, loading: false, failed: false, observer: null};
    // Keep the viewport on the products, rather than anchoring to the footer as it moves.
    // Otherwise a fast swipe to the footer can continually request every remaining page.
    if (s.infinite) { s.anchorStyle = document.documentElement.style.overflowAnchor; document.documentElement.style.overflowAnchor = 'none'; }
    control.onclick = function (event) {
      if (!s.infinite || event.target.closest('[data-infinite-retry]')) { event.preventDefault(); append(s, true); }
    };
    if (s.infinite && 'IntersectionObserver' in window) {
      s.observer = new IntersectionObserver(function () { schedule(); }, {rootMargin: '1400px 0px'});
      s.observer.observe(control);
    }
    schedule();
  }
  window.loadMore = init;
  window.loadItems = function () { if (active) return append(active, true); };
  window.checkVisibility = schedule;
  window.updateShowingText = showing;
  window.resetCollectionPagination = dispose;
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
